import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  AppletService,
  AppletContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-applet',
  templateUrl: './applet.component.html',
  styleUrls: ['./applet.component.css']
})
export class AppletComponent implements OnInit, OnDestroy {

  @Input() applet: FormControl;
  @Output() appletChange = new EventEmitter<FormControl>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<AppletContainerModel[]> = new ReplaySubject<AppletContainerModel[]>(1);
  appletList: AppletContainerModel[];

  constructor( private appletService: AppletService ) {}

  ngOnInit() {
    this.subs.sink = this.appletService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.appletList = resolve.data;
        this.filteredOptions$.next(this.appletList);
      }});
    // if (this.applet.value) {
    //   this.subs.sink = this.appletService.getByGuid(this.applet.value, this.apiVisa).subscribe( resolved => {
    //     this.branchList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterApplet(resolve)});
  }

  filterApplet(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.appletList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.appletList.filter(c => c.bl_applet_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
